import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import hi from "./locales/hi.json";
import mr from "./locales/mr.json";
import bn from "./locales/bn.json";
import id from "./locales/id.json";
import sw from "./locales/sw.json";

// Geography → languages map (drives the language switcher dropdown).
// English is always available as a per-geography fallback.
export const GEOGRAPHIES = [
  { code: "global", flag: "🌐", label: "Global",     languages: [{ code: "en", label: "English" }] },
  { code: "in",     flag: "🇮🇳", label: "India",      languages: [
      { code: "en", label: "English" },
      { code: "hi", label: "हिन्दी (Hindi)" },
      { code: "mr", label: "मराठी (Marathi)" },
  ] },
  { code: "bd",     flag: "🇧🇩", label: "Bangladesh", languages: [
      { code: "en", label: "English" },
      { code: "bn", label: "বাংলা (Bengali)" },
  ] },
  { code: "id",     flag: "🇮🇩", label: "Indonesia",  languages: [
      { code: "en", label: "English" },
      { code: "id", label: "Bahasa Indonesia" },
  ] },
  { code: "af",     flag: "🌍", label: "Africa",     languages: [
      { code: "en", label: "English" },
      { code: "sw", label: "Kiswahili (Swahili)" },
  ] },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi },
      mr: { translation: mr },
      bn: { translation: bn },
      id: { translation: id },
      sw: { translation: sw },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "hi", "mr", "bn", "id", "sw"],
    interpolation: { escapeValue: false },
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"], lookupLocalStorage: "cg.lang" },
  });

export default i18n;
